import React from 'react';
import { Paper } from '../../../v2BaseComponents/Paper';
import MainContentContainer from '../../../v2BaseComponents/MainContentContainer';
import Stack from '../../../v2BaseComponents/Stack';
import { colors } from '../../../../utils/theme';
import Text from '../../../v2BaseComponents/Text';
import { getIntl } from '../../../../utils/intl';

const intl = getIntl('organization-client-invitation-step-paper', {
    step: 'Step {stepCount} - {stepTitle}',
});

export type StepPaperOwnProps = {
    children: React.ReactNode;
    stepIndex: number;
    stepTitle: string;
};

export type StepPaperProps = StepPaperOwnProps;

const StepPaper: React.FC<StepPaperProps> = (props) => {
    return (
        <Paper>
            <Stack
                horizontal
                justify="flex-start"
                fullWidth
                style={{
                    borderBottomWidth: 1,
                    borderBottomColor: colors.Dividers,
                }}
            >
                <MainContentContainer>
                    <Text variant="h4">
                        {intl('step', {
                            stepCount: props.stepIndex + 1,
                            stepTitle: props.stepTitle,
                        })}
                    </Text>
                </MainContentContainer>
            </Stack>
            {props.children}
        </Paper>
    );
};

export default React.memo(StepPaper);
